import React from "react";
import { useL } from "@/lib/useL";
import { API } from "@/lib/api";

// Visible only on paper: QR code + link so students can reopen the online version.
export function PrintQr({ url }) {
  const L = useL();
  if (!url) return null;
  return (
    <div className="sux-print-only" data-testid="print-qr">
      <img src={`${API}/qr?data=${encodeURIComponent(url)}`} alt="QR code" width="96" height="96" />
      <div>
        <div style={{ fontWeight: 700, fontSize: "11pt" }}>Version en ligne de cette fiche</div>
        <div style={{ fontSize: "9pt" }}>{L("Scannez ce code avec l'appareil photo d'un téléphone, ou ouvrez :", "Scan this code with a phone camera, or open:")}</div>
        <div style={{ fontSize: "9pt", wordBreak: "break-all" }}>{url}</div>
        <div style={{ fontSize: "8pt", marginTop: "4px", color: "#555" }}>{L("Réalisé avec SUX1", "Made with SUX1")} · sux1.app</div>
      </div>
    </div>
  );
}

export default PrintQr;
